import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/AlertDialog';
import { Button } from '@/components/ui/Button';
import { Loader2 } from 'lucide-react';

export interface DeleteCampConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  campName: string;
  onConfirm: () => void | Promise<void>;
  loading?: boolean;
}

export function DeleteCampConfirmDialog({
  open,
  onOpenChange,
  campName,
  onConfirm,
  loading = false,
}: DeleteCampConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={(next) => !loading && onOpenChange(next)}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle>Delete camp?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3 text-sm text-muted-foreground">
              <p>
                This will permanently delete <strong className="text-foreground">{campName}</strong>.
                This action cannot be undone.
              </p>
              <p>
                Delete is only available when no students are enrolled. If students are still on the
                roster, cancel the camp or remove them from the Students drawer first.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel type="button" disabled={loading}>
            Keep camp
          </AlertDialogCancel>
          <Button
            type="button"
            variant="destructive"
            disabled={loading}
            onClick={() => void onConfirm()}
          >
            {loading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden />
                Deleting…
              </>
            ) : (
              'Delete camp'
            )}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
